import React from "react";
import { useLocation } from "react-router-dom";
import MessagingPage from "../components/messaging/MessagingPage";

const Messaging = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const initialCategory = searchParams.get("category") || "PROMOTION";

  return <MessagingPage initialCategory={initialCategory} />;
};

export default Messaging;
